import { Button }                  from '@/components/ui/button';
import { Center }                  from '@chakra-ui/react';
import LogoutIcon                  from '@/assets/icons/LogoutIcon';
import { Separator }               from '@chakra-ui/react';
import { Stack }                   from '@chakra-ui/react';
import authStore                   from '@/stores/authStore';
import { useNavigate }             from 'react-router-dom';
import { useTranslation }          from 'react-i18next';
import useTranslations             from '@/hooks/useTranslations';

const NavigationFooter = () => {
    const { t } = useTranslation();
    const { getNavigationTranslation } = useTranslations();
    const navigate = useNavigate();
    return (
        <Stack bg="white" width="100%">
            <Center> <Separator width="80%" /></Center>
            <Button
                variant="ghost"
                onClick={() => {
                    authStore.logout();
                    navigate(getNavigationTranslation('login', 'path'), { state: null });
                }}
                justifyContent="flex-start"
                paddingLeft={0}
                marginLeft={{ base: 0, lg: "30px" }}
                marginRight={{ base: 0, lg: "30px" }}
                _hover={{ bg: "beigeLight" }}
            >
                <LogoutIcon fontSize="20px" />
                {t('components.drawer.actions.logout')}
            </Button>
        </Stack>
    )
}

export default NavigationFooter